import { render, staticRenderFns } from "./SendOTP.vue?vue&type=template&id=32018a0c&scoped=true&"
import script from "./SendOTP.vue?vue&type=script&lang=js&"
export * from "./SendOTP.vue?vue&type=script&lang=js&"
import style0 from "./SendOTP.vue?vue&type=style&index=0&id=32018a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32018a0c",
  null
  
)

export default component.exports